import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiAlertTriangle } from 'react-icons/fi';

export const UrgencyStrip = () => {
  return (
    <div className="bg-gradient-to-r from-red-600/20 via-red-500/20 to-red-600/20 border-y border-red-500/30 py-4 px-4 overflow-hidden relative">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-50"></div>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center z-10 relative">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="flex items-center gap-2 text-red-400 font-bold text-lg md:text-xl"
        >
          <SafeIcon icon={FiAlertTriangle} className="animate-pulse" />
          <span>Financial Year End Offer Ends Tonight</span>
        </motion.div>
        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="text-gray-300 font-medium"
        >
          From tomorrow price goes back to normal
        </motion.div>
      </div>
    </div>
  );
};